module.exports = __webpack_public_path__ + "static/me-f79d5f71a957d3b1a95bcf84220d9224.jpg";